import React from 'react';

// Map sportsbook keys to domains for Google S2 Favicons
const SPORTSBOOK_DOMAINS = {
  draftkings: 'sportsbook.draftkings.com',
  fanduel: 'sportsbook.fanduel.com',
  betmgm: 'sports.betmgm.com',
  williamhill_us: 'caesars.com',
  fanatics: 'sportsbook.fanatics.com',
  espnbet: 'sportsbook.thescore.bet',
  ballybet: 'ballybet.com',
  betrivers: 'betrivers.com',
};


export const SPORTSBOOK_URLS = {
  draftkings: 'https://sportsbook.draftkings.com',
  fanduel: 'https://sportsbook.fanduel.com',
  betmgm: 'https://sports.betmgm.com',
  williamhill_us: 'https://www.caesars.com/sportsbook-and-casino',
  fanatics: 'https://sportsbook.fanatics.com',
  espnbet: 'https://sportsbook.thescore.bet',
  ballybet: 'https://www.ballybet.com',
  betrivers: 'https://www.betrivers.com',
  kalshi: 'https://kalshi.com',
  polymarket: 'https://polymarket.com',
};

// Fallback colors for each sportsbook (used if logo fails to load)
const SPORTSBOOK_COLORS = {
  draftkings: '#53d337',
  fanduel: '#1493ff',
  betmgm: '#bfa15c',
  williamhill_us: '#0a3161',
  fanatics: '#003087',
  espnbet: '#e8371e',
  ballybet: '#e31837',
  betrivers: '#0057a8',
};

function SportsbookLogo({ bookKey, size = 20 }) {
  const domain = SPORTSBOOK_DOMAINS[bookKey];
  const fallbackColor = SPORTSBOOK_COLORS[bookKey] || '#666';
  const initial = bookKey ? bookKey.charAt(0).toUpperCase() : '?';

  // If no domain mapping, show fallback
  if (!domain) {
    return (
      <span
        className="sportsbook-logo-fallback"
        style={{
          width: size,
          height: size,
          backgroundColor: fallbackColor,
          borderRadius: '4px',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: size * 0.6,
          fontWeight: 'bold',
        }}
      >
        {initial}
      </span>
    );
  }

  // Render both image and hidden fallback, show fallback on error
  return (
    <>
      <img
        src={`https://www.google.com/s2/favicons?domain=${domain}&sz=64`}
        alt=""
        className="sportsbook-logo"
        style={{
          width: size,
          height: size,
          borderRadius: '4px',
          objectFit: 'contain',
        }}
        onLoad={(e) => {
          // Google S2 returns a 16x16 generic placeholder when it has no favicon
          if (e.target.naturalWidth <= 16) {
            e.target.style.display = 'none';
            if (e.target.nextSibling) e.target.nextSibling.style.display = 'inline-flex';
          }
        }}
        onError={(e) => {
          e.target.style.display = 'none';
          if (e.target.nextSibling) {
            e.target.nextSibling.style.display = 'inline-flex';
          }
        }}
      />
      <span
        className="sportsbook-logo-fallback"
        style={{
          width: size,
          height: size,
          backgroundColor: fallbackColor,
          borderRadius: '4px',
          display: 'none',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: size * 0.6,
          fontWeight: 'bold',
        }}
      >
        {initial}
      </span>
    </>
  );
}

// Display name mapping
export const SPORTSBOOK_NAMES = {
  draftkings: 'DraftKings',
  fanduel: 'FanDuel',
  betmgm: 'BetMGM',
  williamhill_us: 'Caesars',
  fanatics: 'Fanatics',
  espnbet: 'theScore',
  ballybet: 'Bally Bet',
  betrivers: 'BetRivers',
};

export default SportsbookLogo;
